<script>
    /*
    	VerticalSelectedCategories.svelte
    */

    import { onMount } from 'svelte';
    import { level0Node, level1Node, level2Node, level3Node, level4Node } from '../../stores/ResourceMenuStore.js';
    import { currentMenuNode } from '../../stores/ResourceMenuStore.js';
    

    // TCARE components
    import VerticalSelectedButton from './VerticalSelectedButton.svelte';

    // SMUI components

    export let searchStore;
    export let onSelectedCatButtonClick;        // pass through to button

    $: staticPostalCode = '';                   // does not change when user types new ZIP Code

    onMount(() => {
        staticPostalCode = $searchStore.location.postalCode;
    })

</script>

<style>
    .selected-categories {
        /* height: 300px; */
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        /* border: 1px solid green; */
    }

    /*
    .label-text {
        width: 100%;
        margin: 10px 0px;
        font-size: 13px;
        font-weight: 500;
        color: #A075A5;
    }

    .label-text span {
        color: #604772;
        font-weight: 600;
    }
    */

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="selected-categories">
    <!--
    {#if $level0Node}
        <VerticalSelectedButton category={$level0Node} onClick={() => onSelectedCatButtonClick($level0Node)} />
    {/if}
    -->

    {#if $level1Node}
        <VerticalSelectedButton category={$level1Node} onClick={() => onSelectedCatButtonClick($level1Node)} />
    {/if}

    {#if $level2Node}
        <VerticalSelectedButton category={$level2Node} onClick={() => onSelectedCatButtonClick($level2Node)} />
    {/if}

    {#if $level3Node}
        <VerticalSelectedButton category={$level3Node} onClick={() => onSelectedCatButtonClick($level3Node)} />
    {/if}

    {#if $level4Node}
        <VerticalSelectedButton category={$level4Node} onClick={() => onSelectedCatButtonClick($level4Node)} />
    {/if}

</div>
